import React from "react";
import AdminNavbar from "../Navbars/AdminNavbar.js";
import PortalSidebar from "./PortalSidebar";
import { PortalApis } from "../../apis/PortalApis";
import { useSelector } from 'react-redux';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Oval } from 'react-loader-spinner';
import { SvgElement, icontypesEnum } from "../assets/svgElement";


export default function PortalSettings() {

    const userLoginData = useSelector((state: any) => state.data.login.value);
    const [loading, setLoading] = React.useState<boolean>(true);
    const [saving, setSaving] = React.useState<boolean>(false);
    const [profile, setProfile] = React.useState({
        company_name: '',
        contact_name: '',
        contact_email: '',
        phone_number: '',
        website: '',
        business_description: '',
    });

    React.useEffect(() => {
        PortalApis.getProfile().then((response: any) => {
            setLoading(false);
            if (response?.data?.data) {
                const d = response.data.data;
                setProfile({
                    company_name: d.company_name || '',
                    contact_name: d.contact_name || '',
                    contact_email: d.contact_email || '',
                    phone_number: d.phone_number || '',
                    website: d.website || '',
                    business_description: d.business_description || '',
                });
            }
        }).catch(() => setLoading(false));
    }, []);

    const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        const { name, value } = e.target;
        setProfile({ ...profile, [name]: value });
    };

    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();
        setSaving(true);
        PortalApis.updateProfile(profile).then((response: any) => {
            setSaving(false);
            if (response?.data?.success) {
                toast.success('Profile updated successfully');
            } else {
                toast.warn(response?.data?.message || 'Update failed');
            }
        }).catch((error: any) => {
            setSaving(false);
            toast.error(error?.response?.data?.message || 'Failed to update profile');
        });
    };

    return (
        <>
            <PortalSidebar title="Settings" />
            <div className="relative md:ml-64 bg-[#FAFAFA]">
                <AdminNavbar title="Settings" />
                <div className='lg:px-10 pb-6 px-6 bg-[#FAFAFA] min-h-screen'>

                    <div className="lg:pt-5 pt-3">
                        <h3 className="text-[20px] font-semibold">Account Settings</h3>
                        <p className="text-[13px] font-normal text-[#999999]">Update your profile information</p>
                    </div>

                    {loading ? (
                        <div className="flex justify-center py-16">
                            <Oval visible={true} height="35" width="35" color="#E04343" secondaryColor="#FCBF94" />
                        </div>
                    ) : (
                        <div className="bg-white rounded-[10px] border border-[#E2E8F0] px-[26px] py-[24px] mt-6">
                            <form onSubmit={handleSubmit}>
                                <div className="flex flex-wrap -mx-2">
                                    <div className="lg:w-6/12 w-full px-2">
                                        <div className="flex justify-between mb-3">
                                            <label className="text-[#333333] text-[12px]">Company Name</label>
                                            <SvgElement type={icontypesEnum.QUESTIONMARK} />
                                        </div>
                                        <div className="relative mb-4">
                                            <input type="text" name="company_name" value={profile.company_name} onChange={handleChange}
                                                className="border border-[#D1D1D1] text-gray-900 text-sm rounded-[5px] block w-full pl-4 p-2.5" />
                                        </div>
                                    </div>

                                    <div className="lg:w-6/12 w-full px-2">
                                        <div className="flex justify-between mb-3">
                                            <label className="text-[#333333] text-[12px]">Contact Person</label>
                                            <SvgElement type={icontypesEnum.QUESTIONMARK} />
                                        </div>
                                        <div className="relative mb-4">
                                            <input type="text" name="contact_name" value={profile.contact_name} onChange={handleChange}
                                                className="border border-[#D1D1D1] text-gray-900 text-sm rounded-[5px] block w-full pl-4 p-2.5" />
                                        </div>
                                    </div>

                                    <div className="lg:w-6/12 w-full px-2">
                                        <div className="flex justify-between mb-3">
                                            <label className="text-[#333333] text-[12px]">Email</label>
                                            <SvgElement type={icontypesEnum.QUESTIONMARK} />
                                        </div>
                                        <div className="relative mb-4">
                                            <input type="email" name="contact_email" value={profile.contact_email} disabled
                                                className="border border-[#D1D1D1] text-gray-400 text-sm rounded-[5px] block w-full pl-4 p-2.5 bg-gray-50" />
                                        </div>
                                    </div>

                                    <div className="lg:w-6/12 w-full px-2">
                                        <div className="flex justify-between mb-3">
                                            <label className="text-[#333333] text-[12px]">Phone Number</label>
                                            <SvgElement type={icontypesEnum.QUESTIONMARK} />
                                        </div>
                                        <div className="relative mb-4">
                                            <input type="text" name="phone_number" value={profile.phone_number} onChange={handleChange}
                                                className="border border-[#D1D1D1] text-gray-900 text-sm rounded-[5px] block w-full pl-4 p-2.5" />
                                        </div>
                                    </div>

                                    <div className="lg:w-6/12 w-full px-2">
                                        <div className="flex justify-between mb-3">
                                            <label className="text-[#333333] text-[12px]">Website</label>
                                            <SvgElement type={icontypesEnum.QUESTIONMARK} />
                                        </div>
                                        <div className="relative mb-4">
                                            <input type="url" name="website" value={profile.website} onChange={handleChange}
                                                className="border border-[#D1D1D1] text-gray-900 text-sm rounded-[5px] block w-full pl-4 p-2.5" />
                                        </div>
                                    </div>

                                    <div className="w-full px-2">
                                        <div className="flex justify-between mb-3">
                                            <label className="text-[#333333] text-[12px]">Business Description</label>
                                            <SvgElement type={icontypesEnum.QUESTIONMARK} />
                                        </div>
                                        <div className="relative mb-4">
                                            <textarea name="business_description" value={profile.business_description} onChange={handleChange} rows={3}
                                                className="border border-[#D1D1D1] text-gray-900 text-sm rounded-[5px] block w-full pl-4 p-2.5" />
                                        </div>
                                    </div>
                                </div>

                                <div className="flex justify-end mt-2">
                                    <button type="submit" disabled={saving}
                                        className="text-white bg-[#E04343] rounded-[30px] transition ease-out delay-300 py-[10px] px-[42px] font-[700] text-[14px]">
                                        <span className="flex justify-center gap-3">
                                            <span>Save Changes</span>
                                            <Oval visible={saving} height="20" width="20" color="#fff" secondaryColor="#FCBF94" />
                                        </span>
                                    </button>
                                </div>
                            </form>
                        </div>
                    )}

                    {/* Account Status */}
                    <div className="bg-white rounded-[10px] border border-[#E2E8F0] px-[26px] py-[20px] mt-6">
                        <h4 className="text-[16px] font-[600] mb-2">Account Status</h4>
                        <div className="flex items-center gap-2">
                            <span className="text-[14px]">Status:</span>
                            {userLoginData?.data?.status === 'active' ?
                                <b style={{ fontWeight: "500", fontSize: '14px', backgroundColor: '#C9F0D0', color: '#51CF66', borderRadius: '10px', padding: '2px 10px' }}>Active</b> :
                                <b style={{ fontWeight: "500", fontSize: '14px', backgroundColor: '#FFDDBD', color: '#FF922B', borderRadius: '10px', padding: '2px 10px' }}>{userLoginData?.data?.status}</b>
                            }
                        </div>
                        <p className="text-[12px] text-[#999999] mt-1">Account type: {userLoginData?.data?.account_type || 'Partner'}</p>
                    </div>

                </div>
            </div>
            <ToastContainer position="top-right" autoClose={2000} hideProgressBar={true} />
        </>
    );
}